import { render, staticRenderFns } from "./AuthorEarnings.vue?vue&type=template&id=53611ec5&scoped=true"
import script from "./AuthorEarnings.vue?vue&type=script&lang=ts"
export * from "./AuthorEarnings.vue?vue&type=script&lang=ts"
import style0 from "./AuthorEarnings.vue?vue&type=style&index=0&id=53611ec5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53611ec5",
  null
  
)

export default component.exports